export default __webpack_public_path__ + "static/supporter-bear-e0a35f40fb0f8d5c70a63f40f953d726.svg";